import React from 'react';
import { LoadingSpinner } from './LoadingSpinner.jsx';

export function ContentLoading() {
  return (
    <div className="h-full flex items-center justify-center">
      <LoadingSpinner size="lg" />
    </div>
  );
}
